import { render, staticRenderFns } from "./EditPrefix.vue?vue&type=template&id=58569eb2&scoped=true"
import script from "./EditPrefix.vue?vue&type=script&lang=js"
export * from "./EditPrefix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58569eb2",
  null
  
)

export default component.exports